<template>
    <SectionBase v-if="hasItems" class="RecommendedSection" :title="$t('title')">
        <template v-slot:items>
            <!-- <CoursePreview
        v-for="item of items"
        :key="item.courseId"
        v-bind="item"
      /> -->
            <CourseThumb v-for="item of items" :key="item.courseId" v-bind="item" />
        </template>
    </SectionBase>
</template>

<translations>
  title: 'Memolife recommends'
  title_no: 'Memolife anbefaler'
</translations>

<script>
import SectionBase from './SectionBase';
import CourseThumb from './CourseThumb';

export default {
    components: { SectionBase, CourseThumb },
    computed: {
        items() {
            return this.$store.getters['moduleApp/recommendedByMemolifeItems'];
        },
        hasItems() {
            return this.items.length;
        }
    }
};
</script>
